<template>
    <image :x="x" :y="y" :width="width" :height="width" :xlink:href="color | calcHref" />
</template>
<script>
import ComputerRed from "../assets/animate/computer-red.png"
import ComputerBlue from "../assets/animate/computer-blue.png"
import ComputerOringe from "../assets/animate/computer-oringe.png"


// import fire from "../assets/animate/fire.png"
// import fire2 from "../assets/animate/fire2.png"

// import hacker from "../assets/animate/hacker.png"
export default {
    props: {
        x: {
            type: String,
            required: true
        },
        y: {
            type: String,
            required: true
        },
        width: {
            type: String,
            required: false,
            default: "50"
        },
        name: {

        },
        color: {
            type: String,
            required: false,
            default: "blue"
        },
        
    },
    filters: {
        calcHref(color) {
            let href = ''
            if (color === "blue") {
                href = ComputerBlue
            }
            if (color === "red") {
                href = ComputerRed
            }
            if (color === "oringe") {
                href = ComputerOringe
            }
            return href
        }
    }
}
</script>